
// Single source of truth for the in-flight refresh promise.
//
// Both axios.js (withRFSToken interceptor) and baseQueryWithReauth.js
// import from here — so no matter which system hits a 401 first,
// there is only ever ONE POST /refresh-token in flight at a time.

let refreshPromise = null;

export const getRefreshPromise = () => refreshPromise;

export const setRefreshPromise = (promise) => {
    refreshPromise = promise;
};

export const clearRefreshPromise = () => {
    refreshPromise = null;
};

export const executeRefresh = () => {
    if (!refreshPromise) {
        refreshPromise = fetch(
            `${process.env.REACT_APP_RFS_URL}refresh-token`,
            {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({}),
            }
        ).finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
};